import type { TikTokPage } from '@remotion/captions';
import { DEFAULT_CAPTION_PRESENTATION_TAIL_MS } from '@/shared/lib/captions/caption-presentation-timing';

// 페이지 마지막 token이 끝난 후 자막을 추가로 유지하는 시간(ms).
// 발화가 끝나자마자 자막을 사라지게 하면 가독성이 떨어지므로 짧은 여유를 두되,
// 다음 페이지가 시작되면 그 시점까지로 자동 clamp된다.
export const PAGE_TAIL_PADDING_MS = DEFAULT_CAPTION_PRESENTATION_TAIL_MS;

export type CalculateSubtitleEndFrameInput = {
  page: TikTokPage;
  nextPage: TikTokPage | null;
  fps: number;
  captionOffsetInSeconds: number;
  pageTailPaddingMs?: number;
};

// `page.durationMs`(@remotion/captions가 마지막 token endMs 기준으로 산출)에 padding을
// 더한 시점과, 다음 페이지 시작 시점 중 더 이른 시점을 페이지 종료 frame으로 반환한다.
//
// 이전 구현은 `subtitleStartFrame + 1.2s`로 강제 cap하여 발화가 길 때 자막이 일찍
// 사라지는 회귀가 있었다(예: 3초 발화도 1.2초에 종료). page.durationMs를 직접 쓰면
// 발화 길이만큼 자막이 유지되며, 다음 페이지가 빠르게 이어지면 overlap 없이 clamp된다.
export const calculateSubtitleEndFrame = ({
  page,
  nextPage,
  fps,
  captionOffsetInSeconds,
  pageTailPaddingMs = PAGE_TAIL_PADDING_MS,
}: CalculateSubtitleEndFrameInput): number => {
  const pageEndMs = page.startMs + page.durationMs + pageTailPaddingMs;
  const pageEndFrame = (pageEndMs / 1000) * fps - captionOffsetInSeconds * fps;
  if (!nextPage) return pageEndFrame;
  const nextPageStartFrame =
    (nextPage.startMs / 1000) * fps - captionOffsetInSeconds * fps;
  return Math.min(nextPageStartFrame, pageEndFrame);
};
